var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Feature, Layer } from 'react-mapbox-gl';
import * as React from 'react';
var LINE_LAYOUT = {
    'line-join': 'round',
    'line-cap': 'round',
};
var LINE_PAINT = {
    'line-color': '#f10400',
    'line-width': 4,
};
var Vehicle = /** @class */ (function (_super) {
    __extends(Vehicle, _super);
    function Vehicle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Vehicle.prototype.render = function () {
        return (React.createElement(Layer, { type: "line", id: "shape", layout: LINE_LAYOUT, paint: LINE_PAINT },
            React.createElement(Feature, { coordinates: this.props.coordinates })));
    };
    return Vehicle;
}(React.PureComponent));
export default Vehicle;



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/Line.tsx
// module id = 1767
// module chunks = 0